import React from "react";
import { SideBar } from "./../../sidebar";
import swal from "sweetalert";
import { uploadAdditional, getAuction } from "../../../../models/auctions";
import { AuctionTabs } from "./../../helper/auction_tabs";
import i18n from "../../../../i18n";
import FileInputNew from "../../../helpers/fileInputNew";
import HeaderBanner from "../../../common/HeaderBanner";
import "../../../../styles/components/create-group.scss";
import {
  ArrowLeft,
  Download,
  Expand,
  Eye,
  FileText,
  Loader2,
  Shrink,
} from "lucide-react";

const allowedFormats = [
  "pdf",
  "doc",
  "docx",
  "txt",
  "jpg",
  "jpeg",
  "png",
  "bmp",
  "gif",
];

export class AuctionAdditional extends React.Component {
  constructor() {
    super();
    let path = window.location.pathname;
    let auctionId = path.substring(path.lastIndexOf("/") + 1, path.length);
    this.state = {
      auction: {},
      is_loading: false,
      is_loading_additional: false,
      auctionId: auctionId,
      input: {},
      errors: {},
      file_additional_information: null,
      hideSidebar: false,
    };
    this.onFileChange = this.onFileChange.bind(this);
  }

  componentDidMount() {
    this.loadAuction();
  }

  onFileChange = (event) => {
    let file_format = event.target.files[0].name.split(".").pop().toLowerCase();
    if (!allowedFormats.includes(file_format)) {
      swal("Failed", "Wrong file format", "error");
      return;
    }
    if (event.target.name === "file_additional_information") {
      this.setState({ file_additional_information: event.target.files[0] });
      this.uploadFile(event, "T");
    }
  };

  async loadAuction() {
    this.setState({ is_loading: true });
    const response = await getAuction(this.state.auctionId);
    if (response) {
      let auction = response.data;
      this.setState({ auction });
      this.setState({ is_loading: false });
    }
  }

  async uploadFile(event, fileType) {
    event.preventDefault();
    if (!this.state.auctionId || !event.target.files[0].name) {
      swal("Failed", "File Missing", "error");
      return;
    }
    const formData = new FormData();
    this.setState({ is_loading_additional: true });
    formData.append(
      "file_additional_information",
      event.target.files[0],
      event.target.files[0].name
    );
    formData.append("auction_id", this.state.auctionId);
    const response = await uploadAdditional(formData);
    if (response) {
      this.setState({ is_loading_additional: false });
      if (response.success) {
        this.setState({ auction: response.data });
      } else {
        swal(
          "Failed",
          "Some error occured!! Please make sure that you are uploading proper file.",
          "error"
        );
      }
    }
  }

  render() {
    let { auction } = this.state;
    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t("additional_info")}
          subtitle={
            i18n.t("manage_additional_subtitle") ||
            "Upload additional information files"
          }
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{
                          fontSize: "1rem",
                          marginRight: "0.5rem",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          })
                        }
                      >
                        {this.state.hideSidebar && <Shrink strokeWidth={1} />}
                        {!this.state.hideSidebar && <Expand strokeWidth={1} />}
                      </span>
                    </div>
                    <div className="header-action">
                      <button
                        className="button1 button1-gradient button1-back"
                        onClick={() => window.history.back()}
                      >
                        <ArrowLeft size={18} className="icon" />
                        <span>{i18n.t("back")}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <AuctionTabs activeTab="additional" />
                    <div className="create-group-container">
                      {/* Loading State */}
                      {this.state.is_loading && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "3rem",
                            background: "#f9fafb",
                            borderRadius: "8px",
                          }}
                        >
                          <Loader2
                            className="animate-spin"
                            size={24}
                            style={{ marginRight: "8px" }}
                          />
                          <span>{i18n.t("loading") || "Loading..."}</span>
                        </div>
                      )}

                      {!this.state.is_loading && (
                        <div
                          className="form-content"
                          style={{ flexDirection: "column" }}
                        >
                          <div className="form-section">
                            <h2>
                              {i18n.t("upload")} {i18n.t("additional_info")}
                            </h2>
                            <p
                              style={{
                                fontSize: "0.85rem",
                                color: "#6b7280",
                                marginBottom: "16px",
                              }}
                            >
                              {i18n.t("allowed_formats")}:{" "}
                              {allowedFormats.join(", ")}
                            </p>

                            <div className="upload-field">
                              <label>
                                {i18n.t("additional_info")} *
                              </label>

                              {/* Existing file preview */}
                              {!this.state.is_loading_additional &&
                                auction.file_additional_information && (
                                  <div
                                    className="file-preview-container"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <div className="document-preview">
                                      <div className="document-icon">
                                        <FileText
                                          size={24}
                                          strokeWidth={1.5}
                                        />
                                      </div>
                                      <div className="document-info">
                                        <span className="document-name">
                                          {i18n.t("additional_info")} Document
                                        </span>
                                      </div>
                                      <div className="document-actions">
                                        <a
                                          href={
                                            auction.file_additional_information
                                          }
                                          target="_blank"
                                          rel="noreferrer"
                                          className="preview-action-btn"
                                          title={`${i18n.t("view")}/${i18n.t("download")}`}
                                          style={{
                                            textDecoration: "none",
                                            display: "inline-flex",
                                          }}
                                        >
                                          <Eye size={16} />
                                        </a>
                                        <a
                                          href={
                                            auction.file_additional_information
                                          }
                                          download
                                          target="_blank"
                                          rel="noreferrer"
                                          className="preview-action-btn"
                                          title={i18n.t("download")}
                                          style={{
                                            textDecoration: "none",
                                            display: "inline-flex",
                                          }}
                                        >
                                          <Download size={16} />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                )}

                              {/* Loading */}
                              {this.state.is_loading_additional && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "2rem",
                                    background: "#f9fafb",
                                    borderRadius: "8px",
                                    marginBottom: "12px",
                                  }}
                                >
                                  <Loader2
                                    className="animate-spin"
                                    size={20}
                                    style={{ marginRight: "8px" }}
                                  />
                                  <span>
                                    {i18n.t("uploading") || "Uploading..."}
                                  </span>
                                </div>
                              )}

                              {/* Upload input */}
                              <div className="upload-area">
                                <FileInputNew
                                  className="form-control"
                                  placeholder={i18n.t("choose_file")}
                                  default_placeholder={i18n.t("choose_file")}
                                  id="file_additional_information"
                                  name="file_additional_information"
                                  onChange={this.onFileChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}